import Drawers from './drawers'

export default function init () {
  const drawers = Object.create(Drawers)
  drawers.init()

  window.drawers = drawers
}
